import React from "react";

const Brands = () => {
	return (
		<section className="brand-logos bg-accent mb-10">
			<div className="container mx-auto">
				<div className="flex lg:flex-row flex-col justify-between items-center py-10">
					<div className="lg:w-44">
						<img src={process.env.PUBLIC_URL + "img/hm.png"} alt="" />
					</div>
					<div className="lg:w-44">
						<img src={process.env.PUBLIC_URL + "img/obey.png"} alt="" />
					</div>
					<div className="lg:w-44">
						<img src={process.env.PUBLIC_URL + "img/shopify-2.svg"} alt="" />
					</div>

					<div className="lg:w-44">
						<img src={process.env.PUBLIC_URL + "img/levis.png"} alt="" />
					</div>
					<div className="lg:w-44">
						<img src={process.env.PUBLIC_URL + "img/lacosete.png"} alt="" />
					</div>

					<div className="lg:w-44 self-center">
						<img src={process.env.PUBLIC_URL + "img/amazon.png"} alt="" />
					</div>
				</div>
			</div>
		</section>
	);
};

export default Brands;
